import type * as React from "react";

import type { IControlledInputProps } from "./ControlledInputView";
import ControlledInputView from "./ControlledInputView";
import { modifyState } from "./utils";

interface IProps extends IControlledInputProps {
	exclude: RegExp;
	upper?: boolean;
	lower?: boolean;
}

class ControlledInputViewRegex extends ControlledInputView<IProps> {
	constructor(props: IProps) {
		super(props);
		if (props.upper && props.lower) {
			throw Error("Both upper and lower can't be set");
		}
	}

	updateValue(evt: React.FormEvent<HTMLInputElement>) {
		if (evt.currentTarget.value === "") {
			this.setState(modifyState(this.state, { value: evt.currentTarget.value }));
			this.props.controlledInput.didUpdateValue(evt.currentTarget.value);
			return;
		}
		const reg = this.props.exclude;
		if (reg.test(evt.currentTarget.value)) return;
		if (this.props.maxSize) {
			if (evt.currentTarget.value.length > this.props.maxSize) return;
		}
		let value = evt.currentTarget.value;
		if (this.props.upper) {
			value = value.toUpperCase();
		} else if (this.props.lower) {
			value = value.toLowerCase();
		}
		const newState = modifyState(this.state, { value: value });
		this.setState(newState);
		this.props.controlledInput.didUpdateValue(value);
	}
}

export default ControlledInputViewRegex;
